"use client";

import { usePathname } from "next/navigation";
import Header from "./header";
import Footer from "./footer";

export default function ConditionalShell({ children }: { children: React.ReactNode }) {
  const path = usePathname();
  const isAuth = path.startsWith("/auth");

  return (
    <>
      {!isAuth && <Header />}
      {children}
      {!isAuth && <Footer />}
    </>
  );
}
